import { cn } from '@/utils/cn'
import { type IconProps, iconVariants } from './common'

export function LinkIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M17.8336 6.16638C16.5644 4.89718 14.5067 4.89718 13.2375 6.16638L11.8232 7.58059C11.5303 7.87349 11.0555 7.87349 10.7626 7.58059C10.4697 7.2877 10.4697 6.81283 10.7626 6.51993L12.1768 5.10572C14.0318 3.25073 17.0393 3.25073 18.8943 5.10572C20.7493 6.96071 20.7493 9.96824 18.8943 11.8232L17.4801 13.2374C17.1872 13.5303 16.7123 13.5303 16.4194 13.2374C16.1265 12.9446 16.1265 12.4697 16.4194 12.1768L17.8336 10.7626C19.1028 9.49337 19.1028 7.43558 17.8336 6.16638Z"
        fill="currentColor"
      />
      <path
        d="M7.58059 10.7625C7.87349 11.0554 7.87349 11.5303 7.58059 11.8232L6.16638 13.2374C4.89718 14.5066 4.89718 16.5644 6.16638 17.8336C7.43558 19.1028 9.49337 19.1028 10.7626 17.8336L12.1768 16.4194C12.4697 16.1265 12.9446 16.1265 13.2374 16.4194C13.5303 16.7123 13.5303 17.1871 13.2374 17.48L11.8232 18.8942C9.96824 20.7492 6.96071 20.7492 5.10572 18.8942C3.25073 17.0393 3.25073 14.0317 5.10572 12.1767L6.51993 10.7625C6.81283 10.4696 7.2877 10.4696 7.58059 10.7625Z"
        fill="currentColor"
      />
      <path
        d="M9.34833 13.591C9.05544 13.8839 9.05544 14.3588 9.34833 14.6517C9.64123 14.9446 10.1161 14.9446 10.409 14.6517L14.6516 10.409C14.9445 10.1161 14.9445 9.64126 14.6516 9.34837C14.3587 9.05547 13.8839 9.05547 13.591 9.34837L9.34833 13.591Z"
        fill="currentColor"
      />
    </svg>
  )
}
